module.exports = __webpack_public_path__ + "img/PoweredByWhite.ce674982.png";